import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, Clock, MessageSquare } from 'lucide-react';

export default function CTASection() {
  return (
    <section className="relative bg-[#0a0a0a] py-24 md:py-32 overflow-hidden border-t border-white/10">
      <div className="absolute top-0 inset-x-0 h-20 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" />
      {/* Orange accent line top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-[#C97B2E]" />

      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="font-body text-white/50 text-lg mb-4 max-w-2xl mx-auto">
            Call or message Justin today — no pressure, just a straightforward conversation 
            about your project, your timeline, and what it would take to get it done right.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-10 mt-6">
            <div className="flex items-center gap-2 text-white/60">
              <Clock className="w-4 h-4 text-[#C97B2E]" />
              <span className="font-body text-sm">Response within 1 business day</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <MessageSquare className="w-4 h-4 text-[#C97B2E]" />
              <span className="font-body text-sm">No-pressure consultation</span>
            </div>
            <div className="flex items-center gap-2 text-white/60">
              <ArrowRight className="w-4 h-4 text-[#C97B2E]" />
              <span className="font-body text-sm">Free estimates</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 bg-[#C97B2E] text-[#0a0a0a] px-8 py-4 rounded-sm font-body font-bold uppercase tracking-wider text-sm hover:brightness-110 transition-all duration-300 group w-full sm:w-auto justify-center"
            >
              Request a Free Estimate
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="tel:2812037688"
              className="inline-flex items-center gap-3 border-2 border-white/20 text-white px-8 py-4 rounded-sm font-body font-bold uppercase tracking-wider text-sm hover:border-[#C97B2E] hover:text-[#C97B2E] transition-all duration-300 w-full sm:w-auto justify-center"
            >
              <Phone className="w-4 h-4" />
              (281) 203-7688
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}